import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchActiveSessions, deleteSession, logoutAllApi, type ActiveSession } from '../../lib/api';
import { getAuthSession } from '../../lib/authSession';
import { queryKeys } from './queryKeys';

export const useSessionsQuery = () => {
  const session = getAuthSession();

  return useQuery<ActiveSession[]>({
    queryKey: queryKeys.sessions.list,
    queryFn: () => {
      if (!session) return [];
      return fetchActiveSessions(session.token, session.refreshToken);
    },
    enabled: !!session,
  });
};

export const useDeleteSessionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (sessionId) => {
      const token = getAuthSession()?.token;
      if (!token) throw new Error('Not authenticated');
      return deleteSession(token, sessionId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.sessions.all });
    },
  });
};

export const useLogoutAllMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, void>({
    mutationFn: async () => {
      const token = getAuthSession()?.token;
      if (!token) throw new Error('Not authenticated');
      return logoutAllApi(token);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.sessions.all });
    },
  });
};
